import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import type { ReactNode, CSSProperties } from "react";

type DropdownMenuItem = {
  label: string;
  onClick: () => void;
  color?: string;
};

type DropdownMenuProps = {
  trigger: ReactNode;
  items: DropdownMenuItem[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemClassName?: string;
  contentClassName?: string;
  align?: "start" | "center" | "end";
  sideOffset?: number;
  itemFontSize?: string;
  contentStyle?: CSSProperties;
};

export const DropdownMenu = ({
  trigger,
  items,
  open,
  onOpenChange,
  itemClassName = "w-full bg-white border-none text-left py-2 px-4 cursor-pointer font-sans text-text-primary whitespace-nowrap transition-colors hover:bg-hover-gray outline-none",
  contentClassName = "bg-bg-white shadow-dropdown rounded py-2 z-dropdown w-auto text-black mt-1.5",
  align = "end",
  sideOffset = 5,
  itemFontSize = "12px",
  contentStyle,
}: DropdownMenuProps) => {
  return (
    <RadixDropdown.Root open={open} onOpenChange={onOpenChange}>
      <RadixDropdown.Trigger asChild>{trigger}</RadixDropdown.Trigger>

      <RadixDropdown.Portal>
        <RadixDropdown.Content
          className={contentClassName}
          align={align}
          sideOffset={sideOffset}
          style={contentStyle}
        >
          {items.map((item, index) => (
            <RadixDropdown.Item
              key={index}
              className={itemClassName}
              style={{ fontSize: itemFontSize, color: item.color }}
              onSelect={(event: Event) => {
                event.preventDefault();
                item.onClick();
              }}
            >
              {item.label}
            </RadixDropdown.Item>
          ))}
        </RadixDropdown.Content>
      </RadixDropdown.Portal>
    </RadixDropdown.Root>
  );
};
